import {nameToEffect} from 'effects/EffectsList.js';
import {getNonOverlapping} from 'components/effects/rack/overlaps.js';
import {nameToMidiEffect} from 'effects/midi/getMidiEffect.js';
import {nameToLiveEffect} from 'effects/live/getLiveEffect.js';
import {
    setSelectedEffect,
    } from 'actions/index.js';

export function addEffect(sequencerEngine, command, rack, track=sequencerEngine.getSelectedTrack(), skipSelected) {
    if (track === undefined) {
        return;
    }

    let {effectName, parameters} = getParameters(command);
    if (effectName in nameToEffect) {
        let effect = nameToEffect[effectName](sequencerEngine);
        let selectedEffect = rack || getSelectedEffect(sequencerEngine);
        if (!skipSelected && selectedEffect && selectedEffect.name === "Effect Rack") {
            selectedEffect.addEffect(effect);
            let {x, y} = getNonOverlapping(200, 200, selectedEffect);
            effect.x = x;
            effect.y = y;
        } else {
            track.effects.push(effect);
            sequencerEngine.selectEffect(effect);
        }
 
        effect.enable(true);
        track.updateEffects();
        track.showEffects(true);
        setParameters(effect, parameters);
        return effect;
    } 

    if (effectName in nameToMidiEffect) {
        let midiEffect = nameToMidiEffect[effectName](track);
        let selectedEffect = rack || getSelectedEffect(sequencerEngine);
        if (selectedEffect && selectedEffect.name === "Midi Effect Rack") {
            let {x, y} = getNonOverlapping(200, 200, selectedEffect);
            selectedEffect.addEffect(midiEffect);
            midiEffect.x = x;
            midiEffect.y = y;
        } else {
            track.midiEffects.addEffect(midiEffect);
            sequencerEngine.selectEffect(midiEffect);
        }
        midiEffect.enabled = true;
        track.showEffects(true);
        setParameters(midiEffect, parameters);
        return midiEffect;
    }

    if (effectName in nameToLiveEffect) {
        let fx = nameToLiveEffect[effectName](track);
        track.liveEffects.addEffect(fx);
        fx.enabled = true;
        track.showEffects(true);
        sequencerEngine.store.dispatch(setSelectedEffect(fx.id));
        setParameters(fx, parameters);
        return fx;
    }
}

export function getParameters(str) {
    if (str.includes("[")) {
        // then we must strip it
        let effectName = str.slice(0, str.indexOf("["));
        str = str.includes(']') ?
            str.slice(str.indexOf("[") + 1, str.indexOf("]")) :
            str.slice(str.indexOf('[') + 1);
        let parameters = parseParameterString(str);
        return {effectName, parameters};
    }
    return {effectName: str, parameters: []};
}

function parseParameterString(str) {
    let parameters = [];
    let parameter = '';
    let value = '';
    let isParameter = true;
    let isValue = false;
    for (let i=0; i < str.length; i++) {
        let charAt = str.charAt(i);
        if (charAt == '=') {
            isParameter = false;
            isValue = true;
            continue;
        }

        if (isParameter) {
            parameter += charAt;
        } else if (isValue) {
            if (charAt == ' ') {
                // we found the value so push to list
                parameters.push({
                    parameter: parameter,
                    value: value,
                });
                isValue = false;
                isParameter = true;
                parameter = '';
                value = '';
                continue;
            }

            value += charAt;
        }
    }
    if (parameter !== '') {
        parameters.push({
            parameter, value
        });
    }
    return parameters;
}


function setParameters(effect, parameters) {
    for (let i in parameters) {
        let {parameter, value} = parameters[i];

        let alternateName = parameter.split(' ').join('');
        
        // first see if this parameter even exists
        let effectParameter = effect.parameters.find(
            p => p.name.toLowerCase() === parameter.toLowerCase() ||
                p.name.toLowerCase() === alternateName.toLowerCase());

        if (effectParameter === undefined) {
            continue;
        }

        // now see if theres a percentage in the value
        if (value.includes('%')) {
            value = parseFloat(value.slice(0, value.indexOf('%')));
            let range = effectParameter.max - effectParameter.min;
            effectParameter.set(range * (value / 100.0));
        } else {
            value = parseFloat(value);
            effectParameter.set(value);
        }
    }
}

export function autoCompleteParameter(sequencerEngine, effectName, name) {
    let effect = effectName in nameToEffect ?
        nameToEffect[effectName](sequencerEngine) : 
        nameToMidiEffect[effectName](sequencerEngine.getSelectedTrack())

    name = name.toLowerCase();
    let alternateName = name.split(' ').join('');
    let parameters = effect.parameters;

    return parameters
        .map(p => p.name)
        .filter(n => n.toLowerCase().includes(name) ||
                n.toLowerCase().includes(alternateName));
}

const getSelectedEffect = (sequencerEngine) => {
    let {state} = sequencerEngine;
    if (state.effects.selectedEffect === undefined) {
        return undefined;
    }
    
    let fx = sequencerEngine.selectedEffect;
    return fx;
};


